<template>
  <div>
    <Modal v-model="visible" title="请选择要合并扣税的结算报表" width="1400" :mask-closable="false" :footer-hide="true" :fullscreen="true">
      <div class="search-container">
        <div class="search-box" :class="{ close: !searchMore }">
          <div class="input-item">
            <span class="label">结算日期</span>
            <DatePicker type="date" format="yyyy-MM-dd" placeholder="选择日期" v-model="formData.settlementDate" transfer></DatePicker>
          </div>

          <div class="input-item">
            <span class="label">结算报表名称</span>
            <Input v-model="formData.reportName" clearable placeholder="请输入" />
          </div>

          <div class="input-item">
            <span class="label">结算机构</span>
            <selectTree v-model="formData.orgIds" type="4" :maxTagCount="1" :multiple="true" ref="selectTreeRef"> </selectTree>
          </div>

          <div class="input-item">
            <span class="label">报表类型</span>
            <Select v-model="formData.type" transfer placeholder="请选择" clearable>
              <Option value="1">基本法</Option>
              <Option value="2">增员活动</Option>
              <Option value="3">团险</Option>
              <Option value="4">出单活动</Option>
              <Option value="5">签约活动</Option>
            </Select>
          </div>

          <div class="input-item">
            <span class="label">关联活动</span>
            <Select v-model="formData.activityId" transfer placeholder="请选择" clearable>
              <Option :value="item.id" v-for="(item, index) in activityList" :key="index">{{ item.name }}</Option>
            </Select>
          </div>
        </div>
        <div class="btn-item btn-box">
          <Button type="primary" @click="searchAjax">查询</Button>
          <Button type="primary" class="btn-reset" ghost @click="resetSearch">重置</Button>
          <Button type="primary" ghost v-if="searchMore" @click="searchMore = false"
            >收起
            <Icon type="ios-arrow-up" />
          </Button>
          <Button type="primary" ghost v-else @click="searchMore = true"
            >展开
            <Icon type="ios-arrow-down" />
          </Button>
        </div>
      </div>

      <!-- 工具栏 -->
      <div class="tools-box">
        <div class="left-box">
          <Checkbox v-model="isAll" @on-change="selectAll" :disabled="tableData.length ? false : true">全部</Checkbox>
        </div>
      </div>

      <div class="tableBox">
        <loading :isShow="listLoading" />
        <Table :columns="columns" :data="tableData" @on-selection-change="onSelectChange"> </Table>
      </div>
      <Page
        :total="total"
        :current.sync="pageNum"
        :page-size="pageSize"
        show-total
        @on-change="getList"
        style="text-align: center; margin-top: 20px; margin-bottom: 60px"
      />

      <div class="footer-btn">
        <Button type="primary" @click="ok" :loading="loading">确定</Button>
        <Button @click="visible = false">取消</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import selectTree from '@/components/system/selectTree3';
import selectTreeOld from '@/components/commons/selectTree';
import { pageTool, common } from '@/api/mixins';
import filter from '@/api/filter';
export default {
  mixins: [pageTool, common],
  components: {
    selectTree,
    selectTreeOld
  },
  props: ['reportId'],
  data() {
    return {
      visible: false,
      loading: false,
      formData: {},
      total: null,
      activityList: [],
      columns: [
        {
          type: 'selection',
          width: 60,
          align: 'center'
        },
        {
          title: '结算日期',
          align: 'center',
          key: 'settlementDate',
          minWidth: 120,
          render(h, params) {
            let settlementDate = params.row.settlementDate;
            return <span>{filter.filterTime(settlementDate, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '报表名称',
          align: 'center',
          key: 'reportName',
          minWidth: 250
        },
        {
          title: '结算机构',
          align: 'center',
          key: 'orgName',
          minWidth: 250,
          tooltip: true,
          tooltipMaxWidth: 600
        },
        {
          title: '报表类型',
          align: 'center',
          key: 'type',
          minWidth: 180,
          render(h, params) {
            let type = params.row.type;
            if (type == 1) {
              return <span>基本法</span>;
            } else if (type == 2) {
              return <span>增员活动</span>;
            } else if (type == 3) {
              return <span>团险</span>;
            } else if (type == 4) {
              return <span>出单活动</span>
            } else if (type == 5) {
              return <span>签约活动</span>
            }
          }
        },
        {
          title: '保单数',
          align: 'center',
          key: 'policyNum',
          minWidth: 100
        },
        {
          title: '总保费',
          align: 'center',
          key: 'fee',
          minWidth: 120
        },
        {
          title: '费用合计',
          align: 'center',
          key: 'totalIncome',
          minWidth: 120
        }
      ],
      tableData: [],
      isAll: false, //全部产品
      selectArr: [], //表格选择的数据
      loading: false
    };
  },
  methods: {
    open() {
      this.visible = true;
      this.isAll = false;
      this.selectArr = [];
      this.searchAjax();
      this.getActivityList();
    },
    // 查询
    searchAjax() {
      this.pageNum = 1;
      this.getList();
    },
    // 重置
    resetSearch() {
      this.formData = {};
      this.searchAjax();
    },
    // 获取关联活动
    getActivityList() {
      this.$http({
        url: '/buz/merchantActivity/getList',
        type: 'POST',
        data: {
          pageNo: 1,
          pageSize: 999
        }
      }).then(res => {
        this.activityList = res.data;
      });
    },
    // 获取列表
    getList() {
      this.listLoading = true;
      let data = JSON.parse(JSON.stringify(this.formData));
      data.commissionDate = data.commissionDate && filter.filterTime(data.commissionDate, 'YYYY-MM-DD');
      data.settlementDate = data.settlementDate && filter.filterTime(data.settlementDate, 'YYYY-MM-DD');
      this.$http({
        url: '/buz/userSettlementReport/queryNeedAdd',
        type: 'POST',
        data: {
          pageNo: this.pageNum,
          pageSize: this.pageSize,
          salaryReportId: this.reportId,
          ...data
        }
      })
        .then(res => {
          res.data.forEach(item => {
            this.selectArr.forEach(item2 => {
              if (item.id == item2.id) {
                item._checked = true;
              }
            });
            if (this.isAll) {
              item._checked = true;
              item._disabled = true;
            }
          });
          this.total = res.total;
          this.tableData = res.data;
          this.listLoading = false;
        })
        .catch(e => {
          this.listLoading = false;
        });
    },
    // 全部选择
    selectAll(status) {
      const tableData = JSON.parse(JSON.stringify(this.tableData));
      tableData.forEach(item => {
        item._disabled = status;
        item._checked = status;
      });
      this.tableData = tableData;
      this.selectArr = [];
    },
    // 列表选中
    onSelectChange(curSelectArr) {
      const ids = curSelectArr.map(item => item.id); //当前页勾选的
      const selectIds = this.selectArr.map(item => item.id); //已经添加的数据
      this.tableData.forEach(item => {
        if (ids.includes(item.id) && !selectIds.includes(item.id)) {
          //未添加已勾选的数据时添加数据
          this.selectArr.push(item);
          selectIds.push(item.id);
        } else if (!ids.includes(item.id) && selectIds.includes(item.id)) {
          //添加了未勾选的数据时删除
          this.selectArr.splice(selectIds.indexOf(item.id), 1);
          selectIds.splice(selectIds.indexOf(item.id), 1);
        }
      });
    },
    ok() {
      if (!this.isAll && this.selectArr.length == 0) {
        this.$notice.alert('请至少选择一条数据');
        return;
      }
      this.$http({
        url: '/buz/userSalaryData/saveData',
        type: 'POST',
        data: {
          reportId: this.reportId,
          isAll: this.isAll ? 1 : 0,
          settlementReportIds: this.selectArr.map(item => item.id)
        }
      }).then(res => {
        this.visible = false;
        this.$notice.success('加入结算成功');
        this.$emit('success');
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.search-container {
  position: relative;
  .search-box {
    margin-top: 20px;
  }
  .btn-box {
    position: absolute;
    bottom: 13px !important;
    right: -10px;
  }
}
/deep/ .ivu-icon-ios-close {
  color: #3c464f !important;
}
/deep/.ivu-modal-close {
  top: 0px;
  font-size: 30px;
}
/deep/.ivu-modal-header {
  height: 45px;
  padding-left: 20px;
}
/deep/.ivu-modal-header-inner {
  font-size: 16px;
}
.footer-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  .ivu-btn {
    min-width: 100px;
    margin-right: 10px;
  }
}
</style>
